<template>
    <div
        :id="
            'itb-other-products-' +
            $route.params.productAlias +
            '-subproduct-' +
            $route.params.subproduct
        "
    >
        <hero-cards :cards="heroCards" class="itb-first-hero-card"></hero-cards>

        <section
            v-if="gallery"
            id="itb-other-products-gallery"
            class="mb-0 mb-lg-2"
        >
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery"
                        :key="index"
                        class="col-12 col-sm-6 col-md-4 mb-4"
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>
        <hero-cards :cards="heroCards2"></hero-cards>

        <section
            v-if="gallery2"
            id="itb-other-products-gallery-2"
            class="mb-0 mb-lg-2"
        >
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery2"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>

        <hero-cards :cards="heroCards3"></hero-cards>

        <section
            v-if="gallery3"
            id="itb-other-products-gallery-3"
            class="mb-0 mb-lg-2"
        >
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery3"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>
        <hero-cards :cards="heroCards4"></hero-cards>

        <section
            v-if="gallery4"
            id="itb-other-products-gallery-4"
            class="mb-0 mb-lg-2"
        >
            <div class="container">
                <div class="row">
                    <div
                        v-for="(img, index) in gallery4"
                        :key="index"
                        :class="
                            img.col_classess
                                ? img.col_classess
                                : 'col-12 col-sm-6 col-md-4 mb-4'
                        "
                        v-lazy-container="{ selector: '.itb-lazy' }"
                    >
                        <img
                            :data-src="'/images/articles/' + img.path"
                            :alt="img.title"
                            class="itb-lazy"
                            style="width: 100%"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
    data() {
        return {
            heroCards: [],
            heroCards2: [],
            heroCards3: [],
            heroCards4: [],
            gallery: [],
            gallery2: [],
            gallery3: [],
            gallery4: [],
            pageParams: [],
            graphics: [],
            catalogueLink: "",
        };
    },

    mounted() {
        axios
            .get(
                `/getOtherProductDetailPage/${this.$route.params.productAlias}/${this.$route.params.subproduct}`
            )
            .then((response) => {
                this.heroCards = response.data.heroCards;

                if (response.data.heroCards2) {
                    this.heroCards2 = response.data.heroCards2;
                }

                if (response.data.heroCards3) {
                    this.heroCards3 = response.data.heroCards3;
                }

                if (response.data.heroCards4) {
                    this.heroCards4 = response.data.heroCards4;
                }

                if (response.data.gallery) {
                    this.gallery = response.data.gallery;
                }

                if (response.data.gallery2) {
                    this.gallery2 = response.data.gallery2;
                }

                if (response.data.gallery3) {
                    this.gallery3 = response.data.gallery3;
                }

                if (response.data.gallery4) {
                    this.gallery4 = response.data.gallery4;
                }

                this.pageParams = response.data.params;

                this.setPageParams(this.pageParams);
            })
            .catch((error) => {
                console.log(error);
            });
    },

    computed: {
        ...mapGetters({ appParams: "getAppParams" }),
    },

    methods: {
        ...mapActions(["setPageParams", "setFormParams"]),
    },
};
</script>
